// fetchdata.js

import axios from "axios";

export const fetchData = async (params, setLoading, setData, setSupportList, setAdvSearchList, setServiceList) => {
  try {
    // Build the query string from params
    const queryString = new URLSearchParams(params).toString();

    const response = await axios.get(`/wp-json/v3/search-results/ca-search?${queryString}`);

    console.log("response", response.data);

    setData(response.data.providers); // Set data from the response
    setSupportList(response.data.supportList); // Set support list from the response
    setAdvSearchList(response.data.advServiceList); // Set advanced search list from the response
    setServiceList(response.data.serviceList); // Set service list from the response
  } catch (error) {
    console.error("Error fetching data: ", error);
    console.error("details: ", error.response.data);
  } finally {
    setLoading(false);
  }
};
